import { render, staticRenderFns } from "./DataproposalAuth.vue?vue&type=template&id=511bd488&scoped=true&"
import script from "./DataproposalAuth.vue?vue&type=script&lang=js&"
export * from "./DataproposalAuth.vue?vue&type=script&lang=js&"
import style0 from "./DataproposalAuth.vue?vue&type=style&index=0&id=511bd488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511bd488",
  null
  
)

export default component.exports